import {FormattedMessage} from 'react-intl';

const UpdateDetail = ({label, children}) => {
  return (
    <div className='col-3 pr2'>
      <div className='h5 jumbo mb1'><FormattedMessage id={label}/></div>
      <div className='h4'>{children}</div>
    </div>
  );
};

export default UpdateDetail;
